import { useNavigate } from 'react-router-dom';

interface NotFoundViewProps {
  message: string;
  backTo: string;
  backLabel: string;
}

export function NotFoundView({ message, backTo, backLabel }: NotFoundViewProps) {
  const navigate = useNavigate();
  return (
    <div className="text-center py-12">
      <div className="inline-flex items-center justify-center w-12 h-12 mb-3 bg-gray-100 rounded-full">
        <span className="text-xl text-gray-400">?</span>
      </div>
      <p className="text-sm text-gray-600 mb-4">{message}</p>
      <button onClick={() => navigate(backTo)} className="btn btn-outline text-sm">
        {backLabel}
      </button>
    </div>
  );
}
